import { useEffect, useState } from 'react';
import { selectVacantInfo, selectStages, selectOnboardingDashboard } from 'store';
import { useAppSelector } from 'store/hooks';
import { useMessageProgressBar } from 'hooks/useMessageProgressBar';
import { ProgressBar } from 'components/molecules';
import './RememberHome.scss';
import { Numbers, userStates } from 'utils/helpers/dictionaries';
import OnboardingModal from 'components/molecules/OnboardingModal/OnboardingModal.component';
import { ONBOARDING_MODALS } from 'utils/constants/Onboarding/indexOnboarding';

export const RememberHome = () => {
  const { stages, isLoadingStages } = useAppSelector(selectStages);
  const { isLoadingVacant } = useAppSelector(selectVacantInfo);
  const { showOnboarding, step } = useAppSelector(selectOnboardingDashboard);

  const [stageCount, setStageCount] = useState({
    totalStages: Numbers.zero,
    completedStages: Numbers.zero,
  });

  const { totalStages, completedStages } = stageCount;
  const { name, description } = useMessageProgressBar(
    totalStages,
    completedStages,
    isLoadingStages
  );

  useEffect(() => {
    if (isLoadingStages || isLoadingVacant) return;

    setStageCount({
      totalStages: stages.length,
      completedStages: stages.filter(
        (s) =>
          s.status === userStates.makeProposal.toString() ||
          s.status === userStates.parked.toString()
      ).length,
    });
  }, [isLoadingStages, stages]);

  return (
    <div className={`home-remember ${step === 2 && "home-remember--active"}`}>
      <h2 className="home-remember__info__title">{name}</h2>
      <p className="home-remember__info__text">{description}</p>
      <div className="progess-bar__wrapper">
        {totalStages !== 0 &&
          <ProgressBar
            totalStages={totalStages}
            completedStages={completedStages}
          />
        }
      </div>
      {showOnboarding && step === 2 && (
        <OnboardingModal
          title={ONBOARDING_MODALS[2].TITLE}
          text={ONBOARDING_MODALS[2].TEXT}
          step={Numbers.two}
          className={ONBOARDING_MODALS[2].CLASSNAME}
          trianglePosition={ONBOARDING_MODALS[2].TRIANGLE_POSITION}
        />
      )}
    </div>
  );
};
